import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { resetAtomForFieldAction } from "./ResetAtomForFieldAction";

class SuccessClosedModalAction extends BaseAction<IDefaultActionResult, boolean> {

    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: false,
            message: "",
            status: "fail"
        }
        try {
            updateRecoilState("serviceRequestModalAtom", this?.params || false)
            //Clear all the recoil for service request claim
            await resetAtomForFieldAction.execute();
            actionResult.status = "success"
        } catch (error) {
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const successClosedModalAction = new SuccessClosedModalAction();